<template>
  <div class="main main--hasHeader main--hasFooter">
    <div class="customContainer">
      <h2 class="members__headline">PRIVACY POLICY</h2>
      <div class="members-list" v-if="app_lang_type=='en'">
        <p class="members-list__description">
          Magarigawa Operations K.K. and THE MAGARIGAWA CLUB ASSOCIATION (hereinafter referred to as "the Company") recognize the importance of personal information and are committed to protecting it in order to gain the trust of our customers. We comply with laws and regulations related to the protection of personal information and hereby publish our privacy policy as follows: 
        </p>
        <ol class="members-list__ol03">
          <li class="members-list__li03">Collection of Personal Information
            <ol class="members-list__ol04">
              <li class="members-list__li02_">In providing products and services to our customers, we may collect personal information. The information collected will be for the following purposes and within the scope necessary for those purposes. Personal information will be collected through legal and fair means, and when collecting personal information from someone other than the customer, we will obtain the customer's consent.</li>
              <li class="members-list__li02_">
              (1)	For membership registration and management of registration information at THE MAGARIGAWA CLUB (hereinafter referred to as "the CLUB").</li>
              <li class="members-list__li02_">(2)	To provide services available at the CLUB.</li>
              <li class="members-list__li02_">(3)	For the creation and management of the Members' Book that contains information about the members of the CLUB, and for the distribution of the Members' Book to the members of the CLUB.</li>
              <li class="members-list__li02_">(4)	For billing of membership registration fees and other service charges.</li>
              <li class="members-list__li02_">(5)	For the prevention and response to fraudulent activities.</li>
              <li class="members-list__li02_">(6)	For market research and analysis, and for planning and implementing marketing strategies.</li>
              <li class="members-list__li02_">(7)	For conducting campaigns, surveys, and other activities.</li>
              <li class="members-list__li02_">(8)	For the improvement of the CLUB or its operations, and for the development of new services or products.</li>
              <li class="members-list__li02_">(9)	For customer service inquiries and communication.</li>

            </ol>
          </li>
          <li class="members-list__li03">Management and Protection of Personal Information
            <ol class="members-list__ol04">
              <li class="members-list__li02_">The Company appoints a manager responsible for the management of personal information and conducts appropriate management in each department to maintain its accuracy and prevent leakage to the outside. The Company also takes appropriate security measures against unauthorized access and computer viruses to prevent the loss, destruction, alteration, and leakage of personal information. Access to databases containing personal information is limited to authorized individuals, and strict management is enforced to prevent misuse within the Company. When outsourcing the handling of personal information, we contractually specify necessary matters such as management of personal information, confidentiality, and prohibition of re-disclosure, and ensure proper management. For more details on the security measures taken by the Company, please contact the inquiry contact listed below.
              </li>
            </ol>
          </li>
          <li class="members-list__li03">Provision of Personal Information to Third Parties
            <ol class="members-list__ol04">
              <li class="members-list__li02_">The Company will not disclose or provide personal information to third parties other than subcontractors without the consent of the individual, except in cases permitted as exceptions by law.
              </li>
            </ol>
          </li>
          <li class="members-list__li03">Disclosure and Correction of Personal Information
            <ol class="members-list__ol04">
              <li class="members-list__li02_">The Company will respond to requests from customers to disclose their personal information after verifying their identity through a prescribed document submission process. If a customer requests correction, suspension of use, deletion, etc., of their personal information, we will promptly take such actions if deemed necessary. For procedures and methods, please contact the inquiry contact listed below.
</li>
            </ol>
          </li>
          <li class="members-list__li03">Organizational Structure
            <ul class="members-list__ul02">
              <li class="members-list__li02_">Based on this privacy policy, the Company establishes internal regulations for the protection of personal information and communicates clear guidelines on the handling of personal information to its officers and employees, committing to the protection of personal information.</li>
            </ul>
          </li>
          <li class="members-list__li03">Review
            <ul class="members-list__ul02">
              <li class="members-list__li02_">The handling of personal information by customers will be periodically audited and continuously improved.</li>
            </ul>
          </li>
          <li class="members-list__li03">Contact
            <ul class="members-list__ul02">
              <li class="members-list__li02_">
                Magarigawa Operations K.K.<br>
                Email: board_office@club.magarigawa.com <br>
                TEL: 0470-29-3575
              </li>
            </ul>
          </li>
        </ol>
      </div>
      <div class="members-list" v-else>
        <p class="members-list__description">
          Magarigawa Operations株式会社及び一般社団法人THE MAGARIGAWA CLUB（以下「当社」といいます。）は、個人情報の重要性を認識し、その保護の徹底をはかり、お客様からの信頼を得るために、個人情報の保護に関する法律等を遵守するとともに、ここに当社としてのプライバシーポリシーを公開いたします。
        </p>
        <ol class="members-list__ol03">
          <li class="members-list__li03">個人情報の収集
            <ol class="members-list__ol04">
              <li class="members-list__li02_">当社がお客様に商品、サービス等をご提供するにあたり、お客様から個人情報を提供していただくことがあります。その場合には以下の目的のために収集をし、収集する情報はその目的に必要な範囲内といたします。個人情報を収集するにあたっては、適法かつ公正な手段により行い、個人情報をお客様以外から収集するときは、お客様の同意を得るものとします。</li>
              <li class="members-list__li02_">(1)	THE MAGARIGAWA CLUB（以下「CLUB」といいます。）の会員登録及び登録情報の管理のため</li>
              <li class="members-list__li02_">(2)	CLUBにおいて利用可能な当社サービスの提供のため</li>
              <li class="members-list__li02_">(3)	CLUBの正会員に関する情報を記載したメンバーズブック（以下「メンバーズブック」といいます。）の作成及び管理並びにメンバーズブックのCLUBの正会員に対する配布のため</li>
              <li class="members-list__li02_">(4)	会員登録費その他サービス対価の請求のため</li>
              <li class="members-list__li02_">(5)	不正行為等の防止及び対応のため</li>
              <li class="members-list__li02_">(6)	マーケティングデータの調査及び分析、並びにマーケティング施策の検討及び実施のため</li>
              <li class="members-list__li02_">(7)	キャンペーン、アンケートその他の実施のため</li>
              <li class="members-list__li02_">(8)	CLUB又はCLUBの運営の改善、新規サービス又は商品の開発のため</li>
              <li class="members-list__li02_">(9)	お問い合わせ対応及びお客様へのご連絡のため</li>
            </ol>
          </li>
          <li class="members-list__li03">個人情報の管理・保護について
            <ol class="members-list__ol04">
              <li class="members-list__li02_">当社は、個人情報の管理に際して、管理責任者を置き、当社の各部門ごとにて適切な管理を行い、その正確性を保つとともに、外部への流出防止に努めます。また、当社は、個人情報の紛失・破壊・改ざん・漏洩等を防止するため、外部からの不正アクセス、コンピューターウィルス等の危険に対する適正なセキュリティ対策を実施し、お客様の個人情報の保護に努めます。個人情報に係るデータベース等へのアクセスについては、アクセス権を有するものを限定し、社内においても不正な利用のなされないように厳重に管理します。 個人情報の取扱いを外部に委託する場合には、個人情報の管理、秘密保持、再提供の禁止等、お客様の個人情報の漏洩等なきよう必要な事項を契約で取り決めるとともに、適切な管理を実施させます。当社が講じる安全管理措置のより詳細については、下記7記載のお問い合わせ窓口までお問い合わせ下さい。
              </li>
            </ol>
          </li>
          <li class="members-list__li03">個人情報の第三者提供
            <ol class="members-list__ol04">
              <li class="members-list__li02_">当社は、法令により例外として取扱うことが認められている場合を除き、個人情報をご本人様の同意なしに業務委託先以外の第三者に開示・提供することはありません。
              </li>
            </ol>
          </li>
          <li class="members-list__li03">個人情報の開示及び訂正
            <ol class="members-list__ol04">
              <li class="members-list__li02_">当社は、お客様がご自身の個人情報の開示を希望される場合は、当社所定の書面を提出頂き、ご本人であることを確認させて頂いた上で、その開示に応じます。また、お客様がご自身の個人情報の訂正・利用停止・消去等を希望される場合は、その理由があると判断されるときは、遅滞なく訂正・利用停止・消去等を行います。なお、これらの手続および方法につきましては、下記7記載のお問い合わせ窓口までお問い合わせ下さい。</li>
            </ol>
          </li>
          <li class="members-list__li03">社内体制の整備
            <ul class="members-list__ul02">
              <li class="members-list__li02_">当社はこのプライバシーポリシーに基づき、個人情報の保護に関する社内規定を整備し、当社の役員・従業員等に個人情報の取扱いについて明確な方針を示し、個人情報の保護に努めます。</li>
            </ul>
          </li>
          <li class="members-list__li03">見直し
            <ul class="members-list__ul02">
              <li class="members-list__li02_">お客様の個人情報の取扱いにつきましては、定期的に監査を行い常に改善に努めます。</li>
            </ul>
          </li>
          <li class="members-list__li03">お問い合わせ窓口
            <ul class="members-list__ul02">
              <li class="members-list__li02_">
                Magarigawa Operations株式会社<br>
                Email : board_office@club.magarigawa.com<br>
                TEL : 0470-29-3575
              </li>
            </ul>
          </li>
        </ol>
      </div>
    </div>
  </div>
</template>
<style scoped>
  .members-list__li02_ {
    position:relative;
    /* padding-left:1.2em; */
    font-size:1.7254313578rem;font-weight:normal;line-height:2.01em;letter-spacing:.05em
  }
  .members-list__li02_:before{
    /* position:absolute;left:0;top:0;content:"●";font-size:.9002250563rem */
  }
  .members-list__ol03_{
    margin-bottom:.6001500375rem;padding-left:.4501125281rem
  }  .members-list__li02__:before{
    position:absolute;left:0;top:0;content:"●";font-size:.9002250563rem
  }
  .members-list__ol03_{
    margin-bottom:.6001500375rem;padding-left:.4501125281rem
  }
  .members-list__li03_{
    counter-increment:item;position:relative;padding-left:1.2em;font-size:1.7254313578rem;font-weight:normal;line-height:2.01em;letter-spacing:.05em
  }
  .members-list__li03_:before{
    position:absolute;left:0;top:0;content:counter(item)
  }
  .members-list__ol04_{
    counter-reset:item;padding-left:0rem
  }
  .members-list__li04_{
    counter-increment:item;position:relative;padding-left:2.4em;font-size:1.7254313578rem;font-weight:normal;line-height:2.01em;letter-spacing:.05em
  }
  .members-list__li04:before{
    position:absolute;left:0;top:0;content:"（" counter(item) "）"
  }
</style>
<script>
import { mapState } from 'vuex'
export default {
  name: 'UserPrivacyPolicyView',
  data: function () {
      return {}
  },
  components: {
  },
  methods: {
  },
  computed: {
    ...mapState({
      user: state => state.apidata.user,
      set_lang: state => state.apidata.set_lang,
    }),
    app_lang_type: function (){
            // console.log('com')
            if(this.set_lang){
                return this.set_lang;
            }
            else{
                return this.$store.state.auth.app_lang_type;
            }
    },
  },
  created () {
  },
  mounted: function(){
  },
}
</script>
